/* src/app/order/components/transfer-documents-info/transfer-documents-group-info/style.scss */
nb-card-body {
  padding-left: 16px;
}
.question-green {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-bottom: 18px;
}
.input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.file-button {
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 0.75rem;
  cursor: pointer;
  border-color: #007d40;
  background-color: #f7fbfc;
  border-width: 0.075rem;
  border-style: solid;
  color: #007d40;
  padding: 0.25rem 0.625rem;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
}
.file-button .button-icon {
  margin-right: 5px;
  cursor: pointer;
}
.file-button.details {
  margin-bottom: 20px;
  margin-right: 12px;
  color: #007d40;
  border-color: #585858;
  background-color: white;
  font-weight: normal;
  font-size: 0.725rem;
}
.change-box {
  margin-left: 10px;
  max-width: 70px;
  min-width: 70px;
  border-radius: 16px;
  text-align: center;
  font-size: 10px;
  font-family: Arial, sans-serif;
  font-weight: bold;
  line-height: 1.6;
  height: 16px;
  letter-spacing: 0.55px;
  width: 100%;
  display: inline-block;
  padding-top: 1px;
}
.change-box.client {
  color: #ffffff;
  background-color: #ee7f00;
}
.change-box.reviewer {
  color: #ffffff;
  background-color: #d7273d;
  max-width: 160px;
  min-width: 120px;
}
/*# sourceMappingURL=style.css.map */
